import ReactModal from 'react-modal'
import React, { useState, useEffect } from 'react'
import styles from '../../../components/browser-modal/browser-modal.css'
import customStyles from './confirm-modal.css'
import innerStyles from './students-grades.scss'
import Box from '../../../components/box/box.jsx'
import closeImg from './poopup_btn_icon_close.png'
import { LESSON_PROGRESS_DONE } from '../../lib/constant'
import { getLesson } from '../../api/lesson'

const Studentsgrades = ({ onClose, msg, lesson, ids }) => {
    const initMsg = msg.map((item, index) => ({
        ...item,
        dataIndex: index
    }))

    const statusList = [
        { label: '全部', value: 0 },
        { label: '未提交', value: 1 },
        { label: '待批改', value: 2 },
        { label: '已批改', value: 3 },
        { label: '不通过', value: 4 }
    ]

    const [selectedStatus, setSelectedStatus] = useState(0)
    const [keyword, setKeyword] = useState('')
    const [homeworkList, setHomeworkList] = useState(initMsg || [])
    const [tasks, setTasks] = useState([])

    useEffect(() => {
        const query = {
            clazz_id: ids.clazzId,
            course_id: ids.courseId,
            id: lesson.id
        }
        getLesson(query,{ quiet: true }).then(res => {
            setTasks(res.tasks)
        })
    }, [])

    const handleSearch = e => {
        if (e.keyCode === 13) {
            let list = []
            if (!!keyword.trim()) {
                list = initMsg.filter(item => item.name.includes(keyword))
            } else {
                list = initMsg
            }
            setSelectedStatus(0)
            setHomeworkList(list)
        }
    }

    const handleStatusSelected = (item, index) => {
        setSelectedStatus(index)
        const list = initMsg
        if (!item.value) {
            const tempList = list.filter(e => e.name.includes(keyword))
            setHomeworkList(tempList)
        } else {
            const tempList = list.filter(e => {
                const { status } = statusCaculator(e)
                if (item.value === 3) {
                    return e.name.includes(keyword) && status === 'A' || status === 'B' || status === 'C' || status === 'D'
                }
                return e.name.includes(keyword) && status === item.label
            })
            setHomeworkList(tempList)
        }

    }

    const statusCaculator = item => {
        const grades = [
            { label: 'A', value: 10 },
            { label: 'B', value: 8 },
            { label: 'C', value: 6 },
            { label: 'D', value: 3 }
        ]
        let status = ''
        let color = ''
        if (item.progress === LESSON_PROGRESS_DONE) {
            if (!item.rate) {
                status = '待批改'
                color = '#ff3a30'
            } else {
                const result = grades.find(e => e.value === item.rate)
                status = !!result ? result.label : '不通过'
                color = !!result && result.label ? '#575e75' : '#ff9502'
            }
        } else {
            status = '未提交'
            color = '#bfbfbf'
        }
        return { status, color }
    }

    const handleClick = item => {
        onClose()
        const url = `id=${lesson.id}&clazz_id=${ids.clazzId}&course_id=${ids.courseId}&check=1&student=${item.id}&index=${item.dataIndex}`
        ids.history.push("/lesson?" + url);
    }
    
    return (
        <ReactModal
            isOpen={true}
            className={`${styles.modalContent} ${customStyles.madalBox} ${innerStyles.modalContainer}`}
            overlayClassName={`${styles.modalOverlay} ${customStyles.bgOpactiy}`}
            style={{ width: '960px !important' }}
            closeTimeoutMS={400}
        >
            <div>
                <Box className={`${styles.illustration} ${customStyles.title}`}>
                    学生作业完成情况列表
                    <a onClick={onClose}><img src={closeImg} />关闭</a>
                </Box>

                <Box className={styles.body}>
                    <div className={innerStyles.filterTitle}>
                        <div className={innerStyles.switch}>
                            {
                                statusList.map((item, index) => (
                                    <div
                                        key={item.value}
                                        className={`${innerStyles.switchItem} ${selectedStatus === index && innerStyles.selected}`}
                                        onClick={() => handleStatusSelected(item, index)}
                                    >
                                        <span>{item.label}</span>
                                    </div>
                                ))
                            }
                        </div>
                        <div className={innerStyles.search}>
                            <input
                                value={keyword}
                                placeholder='输入关键词'
                                onChange={e => setKeyword(e.target.value)}
                                onKeyUp={handleSearch}
                            />
                        </div>
                    </div>
                    {
                        !!homeworkList && homeworkList.length > 0 ? <div className={innerStyles.filterArea}>
                            {
                                homeworkList.map((item, index) => {

                                    const { status, color } = statusCaculator(item)

                                    const noWorkTask = lesson.homework_begin_task
                                    const noWorkPercent = item.current_task < lesson.homework_begin_task ? (item.current_task + 1) / noWorkTask : 1
                                    const workPercent = item.current_task >= noWorkTask ? (item.current_task - noWorkTask + 1) / (tasks.length - lesson.homework_begin_task) : 0
                                    const correctPercent = !!item.rate ? 1 : 0

                                    const defaultAvatar = 'http://oss.pkcode.cn/scratch/avatar/default.png'
                                    const headerImg = `https://oss.pkcode.cn/scratch/avatar/${item.id}.png`
                                    

                                    return <div key={index} className={innerStyles.student} onClick={() => handleClick(item)}>
                                        <div className={innerStyles.avatar}>
                                            <img src={item.avatar ? headerImg : defaultAvatar} alt='' />
                                        </div>
                                        <div className={innerStyles.details}>
                                            <div className={innerStyles.name}>
                                                <span>{item.name}</span>
                                                <span>{'>'}</span>
                                            </div>
                                            <div className={innerStyles.status}>
                                                <span style={{ color }}>{status}</span>
                                            </div>
                                            <div className={innerStyles.progress}>
                                                <div className={innerStyles.bar}>
                                                    <div
                                                        style={{ width: 40 * noWorkPercent, backgroundColor: '#007aff' }}
                                                        className={innerStyles.content}
                                                    ></div>
                                                </div>
                                                <div className={innerStyles.bar}>
                                                    <div
                                                        style={{ width: 40 * workPercent, backgroundColor: '#34c758' }}
                                                        className={innerStyles.content}
                                                    ></div>
                                                </div>
                                                <div className={innerStyles.bar}>
                                                    <div
                                                        style={{ width: 40 * correctPercent, backgroundColor: '#5756d7' }}
                                                        className={innerStyles.content}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })
                                // msg.map((item, index) => (
                                //     <div key={item.id} className={customStyles.listBox} onClick={() => handleClick(item)}>
                                //         <span>{item.name}</span>
                                //         <div>
                                //             <span>
                                //                 {item.progress === LESSON_PROGRESS_DONE ? (
                                //                     item.rate == '10' ? ('A') :
                                //                         (item.rate == '8' ? ('B') :
                                //                             (item.rate == '6' ? ('C') :
                                //                                 (item.rate == '3' ? ('D') : ('未批改'))))
                                //                 ) : ('未完成')}
                                //             </span> {`>`}
                                //         </div>
                                //     </div>
                                // ))
                            }
                        </div> : (
                            <div>
                                {window.L('teach.lesson.homeworkNotStarted')}
                            </div>
                        )}
                </Box>
            </div>
        </ReactModal>
    )
}


export default Studentsgrades
